import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { ToastrService } from 'ngx-toastr';

import { Urls } from '../../../../utils/catalogue/urls';
import { ApiService } from '../../../../shared/catalogue/services/api.service';
import { CommonDataService } from '../../../../shared/catalogue/services/common-data.service';
import { DATA_PER_PAGE, CANCEL, File_deleted } from './../../../../app.constant';

const MAX_FILE_SIZE = 1000000;

@Component({
  selector: 'app-forms-disclosure',
  templateUrl: './forms-disclosure.component.html',
  styleUrls: ['./forms-disclosure.component.scss'],
})
export class FormsDisclosureComponent implements OnInit, OnChanges {
  @Input() type;
  @Input() id;

  @Input() data: any[];
  @Input() selectedMainTab:string='';
  files: File[] = [];
  dataFile = 'Upload File';
  userData: any = {};

  sectionList = [];
  subSectionList = [];

  pageSize: number = DATA_PER_PAGE;

  disclosurePDFsData = [];

  constructor(
    public apiService: ApiService,
    private toastr: ToastrService,
    public commonDataService: CommonDataService
  ) {}

  ngOnInit() {
    // this.getSection();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['data'] && this.data) {
      this.filterPdf(this.data);
    }
  }

  getSection = () => {
    this.apiService
      .postData(Urls.getSectionsByType, { typeId: this.id })
      .subscribe((response: any) => {
        this.sectionList = response.data.subTypes;
      });
    this.getDocs();
  };

  getSubSectionsBySection = () => {
    const index = this.sectionList.findIndex(
      (x) => x.sections === this.userData.section
    );
    const id = this.sectionList[index].id;
    this.apiService
      .postData(Urls.getSubSectionsByType, { sectionId: id })
      .subscribe((response: any) => {
        this.subSectionList = response.data.list;
      });
  };

  getDocs = () => {
    this.apiService
      .getData(Urls.getSubSectiondocs)
      .subscribe((response: any) => {
        this.filterPdf(response.data.list);
      });
  };

  public filterPdf(data: any[]) {
    let disclosurePDFsData;
    if(this.selectedMainTab !== 'Expense Ratio'){
       disclosurePDFsData = data.filter((pdf) => {
        return ((pdf.type === 'Disclosure' || pdf.type === '4')&& pdf.subType.toLowerCase()!=='total expense ratio');
      });
    }else{
       disclosurePDFsData = data.filter((pdf) => {
        return ((pdf.type === 'Disclosure' || pdf.type === '4')&& pdf.subType.toLowerCase()==='total expense ratio');
      });
    }
   

    this.disclosurePDFsData = [...disclosurePDFsData];
  }

  viewFile = (path) => {
    window.open(path, '_blank');
  };

  public deleteData(data) {
    const obj = {
      type: data.type,
      id: data.id,
    };
    this.commonDataService
      .confirm('Are you sure want to delete?', 'md')
      .then((confirmed) => {
        if (confirmed) {
          this.apiService
            .postData(Urls.deleteSubSectionDocuments, obj)
            .subscribe((response: any) => {
              this.toastr.success(File_deleted);
              this.getDocs();
            });
        }
      })
      .catch(() => {
        this.toastr.error(CANCEL);
      });
  }
}
